import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_245_83511)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.0614 3.48626C12.4354 2.41385 11.5863 1.56475 10.5139 0.938807C9.44126 0.312893 8.27033 0 7.00021 0C5.73021 0 4.55906 0.312893 3.48649 0.938807C2.41398 1.56466 1.56488 2.41376 0.938903 3.48626C0.312893 4.55884 0 5.73012 0 7.00002C0 8.26991 0.312989 9.44107 0.938807 10.5137C1.56475 11.5859 2.41385 12.4352 3.48636 13.0612C4.55893 13.6871 5.73012 14 7.00008 14C8.27004 14 9.44136 13.6871 10.5139 13.0612C11.5863 12.4354 12.4354 11.5861 13.0613 10.5137C13.6871 9.44107 14 8.26982 14 7.00002C14 5.73012 13.6871 4.55868 13.0614 3.48626ZM8.16696 11.3658C8.16696 11.451 8.13944 11.5223 8.08482 11.58C8.03019 11.6376 7.96331 11.6665 7.88423 11.6665H6.13419C6.05527 11.6665 5.98532 11.6361 5.9246 11.5754C5.86382 11.5146 5.83349 11.4447 5.83349 11.3659V9.63421C5.83349 9.5551 5.86382 9.48519 5.9246 9.42444C5.98536 9.36372 6.05527 9.33342 6.13419 9.33342H7.88423C7.96334 9.33342 8.03042 9.36237 8.08482 9.41984C8.13944 9.47785 8.16696 9.54897 8.16696 9.63421V11.3658ZM8.14863 8.23055C8.1425 8.29127 8.11071 8.34446 8.05315 8.39005C7.99527 8.43551 7.92401 8.4582 7.839 8.4582H6.15267C6.06756 8.4582 5.99465 8.43551 5.93389 8.39005C5.87311 8.34446 5.84269 8.29127 5.84269 8.23055L5.68776 2.57025C5.68776 2.49721 5.71808 2.44265 5.7788 2.40616C5.83965 2.3576 5.91257 2.33324 5.99762 2.33324H8.00309C8.0882 2.33324 8.16105 2.35751 8.2218 2.40616C8.28256 2.44265 8.31273 2.49734 8.31273 2.57025L8.14863 8.23055Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_245_83511" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "14",
      height: "14",
      fill: "white"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }